export const AddressSearchInputTexts = {
	NoMatchesFound: "No matches found.",
	EnterManually: "Enter manually",
};
